const INTERCOM_APP_ID = 'lryqyabv';

export const bootIntercomForUser = (userId) => {
  window.intercomSettings = {
    app_id: INTERCOM_APP_ID,
    user_id: userId.toString(),
  };

  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', window.intercomSettings);
    return;
  }

  const d = document;
  const i = function intercomPlaceholder(...args) {
    i.c(args);
  };
  i.q = [];
  i.c = function intercomCall(args) {
    i.q.push(args);
  };
  w.Intercom = i;

  const load = () => {
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
    const x = d.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  };

  if (document.readyState === 'complete') {
    load();
  } else if (w.attachEvent) {
    w.attachEvent('onload', load);
  } else {
    w.addEventListener('load', load, false);
  }
};

export const shutdownIntercom = () => {
  if (window.Intercom) {
    window.Intercom('shutdown');
  }
};

export const setIntercomLauncherVisible = (visible) => {
  if (window.Intercom) {
    window.Intercom('update', { hide_default_launcher: !visible });
  }
};
